import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-secondary/50">
      <div className="container mx-auto px-3 py-8 sm:px-4 sm:py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <BrandLogo size={24} />
              <h3 className="font-display text-lg font-bold text-foreground">BraceletsByMia</h3>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">
              Handcrafted with love. Each piece tells a story.
            </p>
            <p className="mt-3 text-xs text-muted-foreground italic">
              This could be YOUR brand here ✨
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-foreground text-sm">Shop</h4>
            <div className="mt-3 flex flex-col gap-2">
              <Link to="/products" className="text-sm text-muted-foreground hover:text-foreground transition-colors">All Bracelets</Link>
              <Link to="/products?style=Boho" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Boho</Link>
              <Link to="/products?style=Minimalist" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Minimalist</Link>
              <Link to="/products?style=Beaded" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Beaded</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-foreground text-sm">About</h4>
            <div className="mt-3 flex flex-col gap-2">
              <span className="text-sm text-muted-foreground">Our Story</span>
              <span className="text-sm text-muted-foreground">Materials</span>
              <span className="text-sm text-muted-foreground">Shipping</span>
              <span className="text-sm text-muted-foreground">Returns</span>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-foreground text-sm">Connect</h4>
            <div className="mt-3 flex flex-col gap-2">
              <span className="text-sm text-muted-foreground">Instagram</span>
              <span className="text-sm text-muted-foreground">TikTok</span>
              <span className="text-sm text-muted-foreground">Pinterest</span>
              <span className="text-sm text-muted-foreground">Email</span>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-border pt-6 text-center">
          <p className="text-xs text-muted-foreground">
            ✨ DEMO - This is a showcase store. No real products or payments.
          </p>
          <p className="mt-1 text-xs text-muted-foreground">
            Want a beautiful shop like this for YOUR business?{" "}
            <a href="https://hustlelabs.llc" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-medium text-primary hover:text-foreground transition-colors">
              Built by Hustle Labs <img src="/hustle-labs-logo.png" alt="Hustle Labs" className="inline h-4 w-4" />
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
